import * as Yup from 'yup';

const schema = Yup.object().shape({
    nome: Yup.string().required('O campo deve ser preenchido'),
});

export default schema;